<template>
  <div class="quote-wrapper row">
    <div class="col-lg-3 icon-wrapper">
      <img :src="icon" :alt="'Artist quote ' + name" />
    </div>
    <div class="col-lg-9">
      <div class="quote" v-html="quote"></div>
      <br />
      <div class="artist-link">
        <router-link :to="'/art/' + name" class="artist-name"
          >@{{ name }}</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "quote",
  props: {
    icon: {
      type: String,
      description: "Artist avatar.",
    },
    quote: {
      type: String,
      description: "Artist quote.",
    },
    name: {
      type: String,
      description: "Artist name.",
    },
  },
};
</script>

<style scoped lang="scss">
.quote-wrapper {
  .icon-wrapper {
    text-align: right;
    img {
      width: 80px;
      border-radius: 40px;
      border: 2px solid white;
    }
  }

  .quote {
    color: white;
    font-weight: 600;
  }

  .artist-name {
    font-style: italic;
    color: white;
  }
}

@media (max-width: 991.98px) {
  .quote-wrapper {
    .icon-wrapper {
      text-align: center;
      margin-bottom: 1.25rem;
    }

    .quote,
    .artist-link {
      text-align: center;
    }
  }
}
</style>
